// extracted by mini-css-extract-plugin
export var date = "singleBlog-module--date--43043";
export var editor = "singleBlog-module--editor--34bdb";
export var title = "singleBlog-module--title--c259b";